/*
 * @Auther: 罗耀祖
 * @Date: 2021-09-09 11:18:34
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-07-27 16:38:25
 * @name: 工作流模块api
 * @Description: 工作流模块api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\flow\flow.api.js
 * @Author: desktop
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 工作流版本列表
 */
export const workflowVersiongetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/workflow_version/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 生成新版本号
 */
export const workflowVersiongetVersion = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/workflow_version/getVersion.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取工作流列表
 */
export const workflowGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/workflow/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取流程连线条件
 * @param {Object} data -> {flow_id{String}: 流程ID}
 */
export const workflowGetConditions = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/workflow/getFlow.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取流程步骤和连线信息
 * @param {Object} data -> {flow_id{String}: 流程ID}
 */
export const workflowGetFlowProcess = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/workflow/getFlowProcess.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 保存流程步骤
 * @param {Object} data -> {
 * id{String}: 步骤id 编辑必传
 * flow_id{String}: 流程id 必传
 * process_name{String}: 步骤名称 必传
 * flow_app{String}: 审批场景 agency 经销商 company 内部审批 必传
 * auto_person{String}: 审批人员 1人员 2角色 3业务发起人 必传
 * user_ids{String}: 人员ids 逗号分割 auto_person为1时必传
 * user_text{String}: 人员名 逗号分割 auto_person为1时必传
 * role_ids{String}: 角色ids 逗号分割 auto_person为2时必传
 * role_text{String}: 角色名 逗号分割 auto_person为2时必传
 * work_id{String}: 业务关联人id auto_person为3时必传
 * work_text{String}: 业务关联人名 auto_person为3时必传
 * is_back{String}: 允许回退 1允许 2不允许
 * wf_action{String}: 关联操作
 * wf_mode{String}: 步骤类型 1直线 2流转 3同步
 * style{array}: 前端要存的信息
 * }
 */
export const workflowSaveProcess = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  try {
    if (!data.flow_id) {
      throw '未指定流程id!';
    }
    if (!data.process_name) {
      throw '请输入步骤名称!';
    }
    if (!(data.process_type === 'is_end')) {
      if (!data.wf_mode) {
        throw '请选择步骤类型!';
      }
    }
    if (!(data.process_type === 'repeat_send') && !(data.process_type === 'is_judge') && !(data.process_type === 'is_end')) {
      if (!data.is_back) {
        throw '请选择回退方式!';
      }
    }
    if (!data.style.top || !data.style.left) {
      throw '需上传前端信息,否则将无法正确显示!';
    }
    return apiEditInstance.post('/admin/workflow/saveProcess.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除流程步骤
 * @param {Object} data -> {flow_id{String}: 流程ID,process_id{String}: 步骤ID}
 */
export const workflowDelProcess = (data) => {
  const instance = axios.create();
  const apiDeleteInstance = new apiDelete();
  return apiDeleteInstance.post('/admin/workflow/delProcess.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加步骤连线
 * @param {Object} data -> {flow_id{String}: 流程ID,from{String}: 起始步骤ID,to{String}: 结束步骤ID,condition{String}: 条件,步骤流转时必传}
 */
export const workflowSaveLink = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  return apiAddInstance.post('/admin/workflow/saveLink.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除步骤连线
 * @param {Object} data -> {flow_id{String}: 流程ID,from{String}: 起始步骤ID,to{String}: 结束步骤ID}
 */
export const workflowDelLink = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  return apiAddInstance.post('/admin/workflow/delLink.html', data, instance);
}